import styles from "./Accounting.module.css"
import { UserTotalsIF } from "../reports/types";
import { useState } from "react";

export const AccountingCard = (props: { user: UserTotalsIF }) => {
    const { user } = props
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return <div>
        <div className={styles.user_card}>
            <div className={styles.user_card_info}
                onClick={() => {
                    setIsOpen(!isOpen)
                }}>
                <div className={styles.user_card_name}>
                    <p>{`${user.userId}: ${user.username}`}</p>
                </div>
                {isOpen && <div className={styles.user_card_stats}>
                    <div>
                        <p>Attempted Bets:</p>
                        <p>{user?.attempted || '-'}</p>
                    </div>
                    <div>
                        <p>Unique Bets:</p>
                        <p>{user?.unique || '-'}</p>
                    </div>
                    <div>
                        <p>Placed Bets:</p>
                        <p>{user?.placed || '-'}</p>
                    </div>
                    <div>
                        <p>Bets Won:</p>
                        <p>{user?.won || '-'}</p>
                    </div>
                    <div>
                        <p>Bets Lost:</p>
                        <p>{user?.lost ?? '-'}</p>
                    </div>
                    <div >
                        <p>Total Risked:</p>
                        <p>{`$${(user?.amountRisked || 0).toFixed(2)}`}</p>
                    </div>
                    <div>
                        <p>Total Won:</p>
                        <p style={{ color: 'var(--success)' }}>{`$${(
                            user?.amountWon || 0
                        ).toFixed(2)}`}</p>
                    </div>
                    <div>
                        <p>Total Lost:</p>
                        <p style={{ color: 'var(--danger)' }}>{`$${(
                            user?.amountLost || 0
                        ).toFixed(2)}`}</p>
                    </div>
                    <div>
                        <p>Net:</p>
                        <p
                            style={{
                                color:
                                    !user ||
                                        user?.amountWon === user?.amountLost
                                        ? 'var(--text1)'
                                        : user?.amountWon > user?.amountLost
                                            ? 'var(--success)'
                                            : 'var(--danger)',
                            }}
                        >
                            {`$${(user?.net || 0).toFixed(2)}`}
                        </p>
                    </div>
                    <div>
                        <p>Net Liable:</p>
                        <p
                            style={{
                                color:
                                    !user ||
                                        user?.netLiable === 0
                                        ? 'var(--text1)'
                                        : user?.netLiable > 0
                                            ? 'var(--success)'
                                            : 'var(--danger)',
                            }}
                        >
                            {`$${(user?.netLiable || 0).toFixed(2)}`}
                        </p>
                    </div>
                    <div>
                        <p>Net Bettor Liable:</p>
                        <p
                            style={{
                                color:
                                    !user ||
                                        user?.netBettorLiable === 0
                                        ? 'var(--text1)'
                                        : user?.netBettorLiable > 0
                                            ? 'var(--success)'
                                            : 'var(--danger)',
                            }}
                        >
                            {`$${(user?.netBettorLiable || 0).toFixed(2)}`}
                        </p>
                    </div>
                </div>}
            </div>
        </div>
    </div>
}